import { render, staticRenderFns } from "./StaRecord.vue?vue&type=template&id=a4bab3a4&scoped=true&"
import script from "./StaRecord.vue?vue&type=script&lang=js&"
export * from "./StaRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bab3a4",
  null
  
)

export default component.exports